import { render, staticRenderFns } from "./extraInstruction.vue?vue&type=template&id=ff93c69e&scoped=true&"
import script from "./extraInstruction.vue?vue&type=script&lang=js&"
export * from "./extraInstruction.vue?vue&type=script&lang=js&"
import style0 from "./extraInstruction.vue?vue&type=style&index=0&id=ff93c69e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff93c69e",
  null
  
)

export default component.exports